import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import RPPGWebcam from "./components/RPPGWebcam";
import LoginPage from "./components/LoginPage";
import LanguageState from "./context/language/LanguageState";
import Signup from "./components/SignupPage";
import OtpVerify from "./components/OtpPage";
import SessionTimeoutPopup from "./components/Session";
import PaymentPage from "./components/payment";

/* ================= AUTH ROUTE (LOGIN REQUIRED) ================= */

// function AuthRoute({ children }) {
//   const token = localStorage.getItem("token");

//   if (!token) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// }

/* ================= SCAN ROUTE (LOGIN + PAYMENT REQUIRED) ================= */

// function ScanRoute({ children }) {
//   const token = localStorage.getItem("token");

//   const [loading, setLoading] = useState(true);
//   const [paid, setPaid] = useState(false);

//   useEffect(() => {
//     if (!token) {
//       setLoading(false);
//       return;
//     }

//     const checkPaymentStatus = async () => {
//       try {
//         const res = await fetch(
//           "https://www.careplus.gopillz.com/scan/status/",
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         if (!res.ok) throw new Error("Payment check failed");

//         const data = await res.json();

//         if (data.paid) {
//           setPaid(true);
//           // optional UX sync
//           localStorage.setItem("scanPaid", "true");
//         } else {
//           setPaid(false);
//           localStorage.removeItem("scanPaid");
//         }
//       } catch (err) {
//         console.error("Payment status error:", err);
//         setPaid(false);
//       } finally {
//         setLoading(false);
//       }
//     };

//     checkPaymentStatus();
//   }, [token]);

//   /* ===== RENDER DECISIONS ===== */

//   if (!token) {
//     return <Navigate to="/login" replace />;
//   }

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         <p className="text-gray-500">Verifying payment…</p>
//       </div>
//     );
//   }

//   if (!paid) {
//     return <Navigate to="/payment" replace />;
//   }

//   return children;
// }

/* ================= APP ================= */

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageState>
          <SessionTimeoutPopup />

          <Routes>
            {/* 🔓 Public */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/otp" element={<OtpVerify />} />
            <Route path="/signup" element={<Signup />} />

            {/* 💳 Payment (Login Required) */}
            {/* <Route
              path="/payment"
              element={
                // <AuthRoute>
                  <PaymentPage />
                // </AuthRoute>
              }
            /> */}

            {/* 📷 Scan (Login + Payment Required) */}
            <Route
              path="/scan"
              element={
                // <ScanRoute>
                  <RPPGWebcam />
                // </ScanRoute>
              }
            />

            {/* 🏠 Default */}
            <Route path="/" element={<Navigate to="/scan" replace />} />

            {/* ❓ Catch-all */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </LanguageState>
      </BrowserRouter>
    </div>
  );
}

export default App;